import {
  BRANDING_COLOR_LOGO,
  BRANDING_WHITE_LOGO,
  BRANDING_BG_IMAGE,
} from 'portal-modules/auth/constants/keys'
import { localStorage as local } from '@entrata/utils'
import getBrandingSettings from 'portal-modules/auth/utils/get-branding-settings'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

const rpSettings = isRP && getBrandingSettings(window.rpSettings)

const useBrandingFrom = rpSettings?.useBrandingFrom

const propertyBranding = isRP && rpSettings?.clientProperties?.[useBrandingFrom]?.branding || {}

const getBrandingValueByKey = (key) => isRP && propertyBranding?.[key] || ''

export const getBrandingLogo = {
  colorLogo: isRP && getBrandingValueByKey(BRANDING_COLOR_LOGO) || '',
  whilteLogo: isRP && getBrandingValueByKey(BRANDING_WHITE_LOGO) || '',
  bgImage: isRP && getBrandingValueByKey(BRANDING_BG_IMAGE) || '',
}
